<template>
  <grid-component
    isResizable
    isReorderable
    :gridId="gridId"
    :itemData="itemData"
    :fields="fields"
    :onDelete="onDelete"
  />
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import debounce from 'lodash/debounce';

  import { GRID_ID } from '@/shared/constants';
  import { prepareColumnsData } from '@/shared/helpers';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';
  import fields from './fields';

  export default {
    props: {
      receivePaymentId: 0,
    },
    components: {
      GridSettings,
      GridComponent,
    },
    data: () => ({
      prepareColumnsData,
      fields,
      gridId: GRID_ID.RECEIVE_PAYMENT_DETAIL,
    }),
    computed: {
      ...mapGetters('receivePayments', ['selectedItemId', 'receivePaymentLines']),
      ...mapGetters('account', ['gridSettingsById']),
      gridSettings() {
        return this.gridSettingsById(this.gridId);
      },
      itemData() {
        return this.receivePaymentLines.map((payment) => ({ ...payment }));
      },
    },
    methods: {
      ...mapActions('receivePayments', ['getByLines', 'deleteByLineId']),
      ...mapActions('account', ['saveGridSettings']),
      async onDelete({ id, paymentId }) {
        const deleteConfirmed = await this.openConfirmBox({ message: 'Are you sure you want to delete payment?  This action cannot be undone.' });
        if (deleteConfirmed) {
          await this.deleteByLineId({ id, paymentId });
          //Get the data
          this.getByLines(this.receivePaymentId);
        }
      },
    },
    watch: {
      receivePaymentId() {
        this.getByLines(this.receivePaymentId);
      },
    },
    mounted() {
      if (this.receivePaymentId)
        this.getByLines(this.receivePaymentId);
    },
  };
</script>

<style lang="scss" scoped>
  .grid {
    height: auto !important;
  }

  .disabled-btn {
    color: #dddddd;
    cursor: no-drop;
  }
</style>

